import { useParams } from "react-router-dom";
import { TeamsPage } from "../Teams/TeamsPage";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag/useFeatureFlag";
import { Flags } from "../../../feature-flags/flags";
import { useProducts } from "../../../hooks/useProducts/useProducts";
import { useUserContext } from "../../../providers/UserProvider";
import { Typography } from "@optimizely/axiom";
import { LoadingIndicator } from "../../components/LoadingIndicator/LoadingIndicator";
import React from "react";
import { ANALYTICS_FLOWS } from "../../../constants/analytics-constants";
import { Unauthorized } from "../Unauthorized/Unauthorized";

export const AccessManagementTeams = () => {
    const { variables } = useFeatureFlag(Flags.ENABLE_TEAM_GROUPS);
    const { enabled: useSupportsTeamsProperty } = useFeatureFlag(Flags.USE_SUPPORTS_TEAMS_PROPERTY);
    const { eligible_product_ids: eligibleProductIds = {} } = variables || {};
    const { productId, instanceId } = useParams();
    const { organizationId = "" } = useUserContext();
    const { products, isLoading, error } = useProducts({ organizationId });

    const product = products?.find((p) => p.id === productId);
    const instance = product?.instances.find((inst) => inst.id === instanceId);

    if (isLoading) {
        return <LoadingIndicator height="100%" type="spinner" />;
    }
    if (error) {
        return (
            <Typography type="body" className="push-double--top">
                Unable to load instance details. Please try again.
            </Typography>
        );
    }

    const isEligibleProduct = useSupportsTeamsProperty
        ? Boolean(product?.supportsTeams)
        : Boolean((eligibleProductIds as { [key: string]: string })[productId ?? ""]);

    if (!isEligibleProduct) {
        return <Unauthorized />;
    }
    if (!instance) {
        return (
            <Typography type="body" className="push-double--top">
                Unable to load instance details. The instance may not exist or you may not have access to it.
            </Typography>
        );
    }
    if (!instance?.optiIdEnabled) {
        return (
            <Typography type="body" className="push-double--top">
                This instance must be Opti ID Enabled in order to add teams.
            </Typography>
        );
    }
    return <TeamsPage analyticsFlow={ANALYTICS_FLOWS.PRODUCT_ACCESS} hideFilters instanceId={instanceId} />;
};

AccessManagementTeams.displayName = "AccessManagementTeams";
